<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-7>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("Toolbar.ConsentOverview") }}</h2>
          </v-flex>
        </v-layout>
        <div class="pa-5">
          <v-layout row wrap justify-center align-baseline>
            <v-flex xs12 lg12>
              <v-item-group mandatory>
                <v-row>
                  <v-col
                    class=""
                    v-for="(item, index) in textactive"
                    :key="index"
                    cols="12"
                    md="4"
                  >
                    <v-item v-slot="{ active, toggle }">
                      <v-card
                        style="border-radius: 20px"
                        :color="active ? '#fff' : ''"
                        class="d-flex align-baseline justify-center flex-column"
                        @click="
                          () => {
                            toggle();
                            Fn_GotoPath(item.value);
                          }
                        "
                      >
                        <v-card-text class="pa-3">
                          <v-layout row wrap justify-center align-center>
                            <v-flex xs3 sm3 md3 lg3>
                              <v-avatar size="50" color="#077893">
                                <v-icon dark>{{ item.icon }} </v-icon>
                              </v-avatar>
                            </v-flex>
                            <v-flex xs7 sm7 md7 lg7>
                              <b
                                v-if="$t('default') === 'th'"
                                class="black--text"
                                >{{ item.text }}</b
                              >
                              <b v-else class="black--text">{{
                                item.textEng
                              }}</b>
                              <div class="mt-3">
                                <span>
                                  <b
                                    class="mt-3"
                                    style="color: #077893; font-size: 40px"
                                  >
                                    {{ item.num }}</b
                                  >
                                  {{ $t("dashboardUser.list") }}</span
                                >
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                        <div v-if="active" class="text-start">
                          <v-divider
                            color="#077893"
                            vertical
                            style="
                              border-width: thick;
                              position: absolute;
                              top: 0;
                            "
                          ></v-divider>
                        </div>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-item-group>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-space-between align-stretch mt-4 mb-4>
            <v-flex xs12 sm12 md12 lg12>
              <v-card style="border-radius: 20px">
                <v-card-text class="pa-2">
                  <v-layout row wrap justify-center align-start>
                    <v-flex xs12 lg6 class="overflow-auto rounded-lg">
                      <v-card
                        class="elevation-0"
                        v-for="(item, index) in BusinessConsent2"
                        :key="index"
                      >
                        <v-card-title class="font-weight-bold">
                          <div
                            v-if="$t('default') === 'th'"
                            class="text-truncate"
                            style="color: #077893"
                          >
                            {{ item.BusinessNameTh }}
                          </div>
                          <div
                            v-else
                            class="text-truncate"
                            style="color: #077893"
                          >
                            {{ item.BusinessNameEng }}
                          </div>
                        </v-card-title>
                        <v-card-text>
                          <h1
                            class="mb-1"
                            style="color: #077893; font-size: 40px"
                          >
                            {{ item.CountBiz }}
                          </h1>
                          {{ $t("dashboardUser.list") }}
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 lg6 py-2>
                      <div id="chart" v-if="$t('dafault') === 'th'">
                        <center>
                          <apexchart
                            type="pie"
                            width="300"
                            :options="chartOptionsee"
                            :series="seriesee"
                          ></apexchart>
                        </center>
                      </div>
                      <div id="chart" v-else>
                        <center>
                          <apexchart
                            type="pie"
                            width="300"
                            :options="chartOptionseeEng"
                            :series="seriesee"
                          ></apexchart>
                        </center>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center justify-center>
            <v-flex xs12 sm12 md12 lg12 py-2>
              <v-card style="border-radius: 20px">
                <v-card-title class="font-weight-bold">
                  <v-avatar size="40" color="#077893">
                    <v-icon dark>mdi-signal-cellular-1 </v-icon>
                  </v-avatar>
                  &nbsp;{{ $t("dashboardUser.Totalmonth") }}</v-card-title
                >
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12 sm12 md12 lg12 text-center>
                    <v-container>
                      <v-card-text>
                        <apexchart
                          v-if="$t('default') === 'th'"
                          class="pa-5"
                          height="250"
                          type="bar"
                          :options="chartOptions"
                          :series="series"
                        >
                        </apexchart>
                        <apexchart
                          v-else
                          class="pa-5"
                          height="250"
                          type="bar"
                          :options="chartOptionsEng"
                          :series="series"
                        >
                        </apexchart>
                      </v-card-text>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { OverlaySearch },
  data() {
    return {
      loadingDownloadData: false,
      ymth: [],
      ymeng: [],
      count: [],
      Count: "",
      CountGeneral: [],
      CountGroup: [],
      SourceSystem: [],
      Status: [],
      chartOptionsEng: {
        plotOptions: {
          bar: {
            distributed: true,
          },
        },
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: [],
        },
      },
      chartOptions: {
        plotOptions: {
          bar: {
            distributed: true,
          },
        },
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: [],
        },
      },
      series: [
        {
          name: "issue",
          data: [],
        },
      ],
      chartOptionsDonut: {
        plotOptions: {
          pie: {
            donut: {
              distributed: true,
              columnWidth: "10%",
              distributed: true,
              borderRadius: 10,
              labels: {
                show: false,
                total: {
                  showAlways: false,
                  show: false,
                  fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                  fontWeight: 600,
                  fontSize: 20,
                  cssClass: "apexcharts-yaxis-label",
                },
              },
            },
          },
        },
        chart: {
          width: 50,
          type: "donut",
        },
        colors: ["#4caf50", "#ff5252", "#fb8c00", "#9e9e9e"],
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: "gradient",
        },
        legend: {
          show: false,
        },
        tooltip: {
          enabled: false,
          theme: "dark",
        },
        responsive: [
          {
            breakpoint: 50,
          },
        ],
      },
      DataNull: [0, 0, 0, 0],
      CheckResAll: "",
      CheckResGrneral: "",
      CheckResGroup: "",
      // textactive: [
      //   { text: "{{$t("dashboardUser.list")}}ขอความยินยอม", value: 1 },
      //   { text: "ความยินยอมทั่วไป", value: 2 },
      //   { text: "ความยินยอมแบบกลุ่ม", value: 3 },
      // ],
      textactive: [],
      DashboardConsent2: [],
      BusinessConsent2: [],
      seriesee: [],
      chartOptionseeEng: {
        chart: {
          width: 380,
          type: "pie",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: "gradient",
        },
        legend: {
          formatter: function (val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex];
          },
        },
        title: {
          text: "",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      chartOptionsee: {
        chart: {
          width: 380,
          type: "pie",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: "gradient",
        },
        legend: {
          formatter: function (val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex];
          },
        },
        title: {
          text: "",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      numtest: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      CountBiz: [],
      Send: [],
      BusinessName: [],
      BusinessNameth: "",
      BusinessNameeng: "",
    };
  },
  methods: {
    Fn_GotoPath(val) {
      this.$router.push("/consent-list");
    },
    async Fn_GetDataDashboard() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "dashbord/user/consent2",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          if (response.status === 200) {
            // this.data = response.data;
            this.DashboardConsent2 = response.data;
            this.Send = response.data.Send;
            this.BusinessConsent2 = response.data.Business;
            this.CountBiz = response.data.Business[0].CountBiz;
            this.BusinessNameTh = response.data.Business[0].BusinessNameTh;
            this.BusinessNameEng = response.data.Business[0].BusinessNameEng;
            this.textactive = [
              {
                icon: "mdi-tune-variant",
                text: "รายการขอความยินยอม",
                textEng: "Consent request",
                value: 1,
                num: this.Send.Count,
              },
              {
                icon: "mdi-vector-line",
                text: "ความยินยอมทั่วไป",
                textEng: "General Consent",
                value: 2,
                num: this.Send.CountGeneral,
              },
              {
                icon: "mdi-vector-square",
                text: "ความยินยอมแบบกลุ่ม",
                textEng: "Group Consent",
                value: 3,
                num: this.Send.CountGroup,
              },
            ];
            var BusinessNameTh = [];
            var BusinessNameEng = [];
            var CountBiz = [];
            for (var i = 0; i < this.BusinessConsent2.length; i++) {
              BusinessNameTh.push(this.BusinessConsent2[i].BusinessNameTh);
              BusinessNameEng.push(this.BusinessConsent2[i].BusinessNameEng);
              CountBiz.push(this.BusinessConsent2[i].CountBiz);

              // this.ymeng.push(this.YearMonth[i].YearMonthEng);
              // this.count.push(this.YearMonth[i].Count);
              this.chartOptionsee = {
                labels: BusinessNameTh,
                tooltip: {
                  theme: "dark",
                  style: {
                    fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                    fontWeight: 600,
                    fontSize: 22,
                  },
                },
                colors: [
                  "#3B93A5",
                  "#F7B844",
                  "#ADD8C7",
                  "#EC3C65",
                  "#CDD7B6",
                  "#C1F666",
                  "#D43F97",
                  "#1E5D8C",
                  "#421243",
                  "#7F94B0",
                  "#EF6537",
                  "#C0ADDB",
                ],
              };
              this.chartOptionseeEng = {
                labels: BusinessNameTh,
                tooltip: {
                  theme: "dark",
                  style: {
                    fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                    fontWeight: 600,
                    fontSize: 22,
                  },
                },
                colors: [
                  "#3B93A5",
                  "#F7B844",
                  "#ADD8C7",
                  "#EC3C65",
                  "#CDD7B6",
                  "#C1F666",
                  "#D43F97",
                  "#1E5D8C",
                  "#421243",
                  "#7F94B0",
                  "#EF6537",
                  "#C0ADDB",
                ],
              };
              this.seriesee = CountBiz;
            }
            this.YearMonth = response.data.YearMonth;
            for (var i = 0; i < this.YearMonth.length; i++) {
              this.ymth.push(this.YearMonth[i].YearMonthTh);
              this.ymeng.push(this.YearMonth[i].YearMonthEng);
              this.count.push(this.YearMonth[i].Count);
              (this.chartOptions = {
                plotOptions: {
                  bar: {
                    distributed: true,
                    columnWidth: "10%",
                    distributed: true,
                    borderRadius: 5,
                    dataLabels: {
                      position: "top",
                      enabled: true,
                    },
                  },
                },
                chart: {
                  id: "vuechart-example",
                  toolbar: {
                    show: false,
                  },
                },
                xaxis: {
                  categories: this.ymth,
                  labels: {
                    show: true,
                    style: {
                      fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                      fontWeight: 600,
                      cssClass: "apexcharts-yaxis-label",
                      fontSize: 9,
                    },
                  },
                },
                yaxis: {
                  labels: {
                    show: true,
                    style: {
                      fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                      fontWeight: 600,
                      cssClass: "apexcharts-yaxis-label",
                    },
                    formatter: (val) => {
                      return val.toLocaleString("en-US");
                    },
                  },
                },
                colors: [
                  "#3B93A5",
                  // "#F7B844",
                  // "#ADD8C7",
                  // "#EC3C65",
                  // "#CDD7B6",
                  // "#C1F666",
                  // "#D43F97",
                  // "#1E5D8C",
                  // "#421243",
                  // "#7F94B0",
                  // "#EF6537",
                  // "#C0ADDB",
                ],
                dataLabels: {
                  enabled: true,
                  offsetY: -30,
                  style: {
                    colors: ["#077893"],
                    fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                    fontWeight: 600,
                    cssClass: "apexcharts-yaxis-label",
                  },
                  formatter: function (val) {
                    return val.toLocaleString("en-US");
                  },
                },
                fill: {
                  type: "gradient",
                },
                legend: {
                  show: false,
                },
                tooltip: {
                  theme: "dark",
                  style: {
                    fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                    fontWeight: 600,
                  },
                  x: {
                    show: true,
                  },
                  y: {
                    title: {
                      formatter: function (a, b, c) {
                        return "";
                      },
                    },
                  },
                },
              }),
                (this.chartOptionsEng = {
                  plotOptions: {
                    bar: {
                      distributed: true,
                      columnWidth: "10%",
                      distributed: true,
                      borderRadius: 5,
                      dataLabels: {
                        position: "top",
                        enabled: true,
                      },
                    },
                  },
                  chart: {
                    id: "vuechart-example",
                    toolbar: {
                      show: false,
                    },
                  },
                  xaxis: {
                    categories: this.ymeng,
                    labels: {
                      show: true,
                      style: {
                        fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                        fontWeight: 600,
                        cssClass: "apexcharts-yaxis-label",
                        fontSize: 9,
                      },
                    },
                  },
                  yaxis: {
                    labels: {
                      show: true,
                      style: {
                        fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                        fontWeight: 600,
                        cssClass: "apexcharts-yaxis-label",
                      },
                      formatter: (val) => {
                        return val.toLocaleString("en-US");
                      },
                    },
                  },
                  colors: [
                    "#3B93A5",
                    // "#F7B844",
                    // "#ADD8C7",
                    // "#EC3C65",
                    // "#CDD7B6",
                    // "#C1F666",
                    // "#D43F97",
                    // "#1E5D8C",
                    // "#421243",
                    // "#7F94B0",
                    // "#EF6537",
                    // "#C0ADDB",
                  ],
                  dataLabels: {
                    enabled: true,
                    offsetY: -30,
                    style: {
                      colors: ["#077893"],
                      fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                      fontWeight: 600,
                      cssClass: "apexcharts-yaxis-label",
                    },
                    formatter: function (val) {
                      return val.toLocaleString("en-US");
                    },
                  },
                  fill: {
                    type: "gradient",
                  },
                  legend: {
                    show: false,
                  },
                  tooltip: {
                    theme: "dark",
                    style: {
                      fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                    },
                    x: {
                      show: true,
                    },
                    y: {
                      title: {
                        formatter: function (a, b, c) {
                          return "";
                        },
                      },
                    },
                  },
                }),
                (this.series = [
                  {
                    name: "issue",
                    data: this.count,
                  },
                ]);
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            // Toast.fire({
            //   icon: "error",
            //   title:  error.message || error,
            // });
          }
        });
    },
    async Fn_GetDashboard() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "dashbord/user/consent2",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.statusText === "OK") {
            this.consent = response.data;
            this.Count = response.data.Send.Count;
            this.CountGeneral = response.data.Send.CountGeneral;
            this.CountGroup = response.data.Send.CountGroup;
            this.SourceSystem = response.data.SourceSystem;
            this.Status = response.data.Status;

            this.dataToArrayAll = [
              this.Status.CountApprove,
              this.Status.CountUnApprove,
              this.Status.CountWait,
              this.Status.CountExpire,
            ];
            this.dataToArrayGeneral = [
              this.CountGeneral.Approve,
              this.CountGeneral.UnApprove,
              this.CountGeneral.Wait,
              this.CountGeneral.Expire,
            ];
            this.dataToArrayGroup = [
              this.CountGroup.Approve,
              this.CountGroup.UnApprove,
              this.CountGroup.Wait,
              this.CountGroup.Expire,
            ];
            this.CheckResAll =
              this.dataToArrayAll.length === this.DataNull.length &&
              this.dataToArrayAll.every(
                (value, index) => value === this.DataNull[index]
              );
            this.CheckResGrneral =
              this.dataToArrayGeneral.length === this.DataNull.length &&
              this.dataToArrayGeneral.every(
                (value, index) => value === this.DataNull[index]
              );
            this.CheckResGroup =
              this.dataToArrayGroup.length === this.DataNull.length &&
              this.dataToArrayGroup.every(
                (value, index) => value === this.DataNull[index]
              );

            this.YearMonth = response.data.YearMonth;
            for (var i = 0; i < this.YearMonth.length; i++) {
              this.ymth.push(this.YearMonth[i].YearMonthTh);
              this.ymeng.push(this.YearMonth[i].YearMonthEng);
              this.count.push(this.YearMonth[i].Count);
              (this.chartOptions = {
                plotOptions: {
                  bar: {
                    distributed: true,
                    columnWidth: "10%",
                    distributed: true,
                    borderRadius: 10,
                    dataLabels: {
                      position: "top",
                      enabled: true,
                    },
                  },
                },
                chart: {
                  id: "vuechart-example",
                  toolbar: {
                    show: false,
                  },
                },
                xaxis: {
                  categories: this.ymth,
                  labels: {
                    show: true,
                    style: {
                      fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                      fontWeight: 600,
                      cssClass: "apexcharts-yaxis-label",
                    },
                  },
                },
                yaxis: {
                  labels: {
                    show: true,
                    style: {
                      fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                      fontWeight: 600,
                      cssClass: "apexcharts-yaxis-label",
                    },
                    formatter: (val) => {
                      return val.toLocaleString("en-US");
                    },
                  },
                },
                colors: [
                  "#3B93A5",
                  "#F7B844",
                  "#ADD8C7",
                  "#EC3C65",
                  "#CDD7B6",
                  "#C1F666",
                  "#D43F97",
                  "#1E5D8C",
                  "#421243",
                  "#7F94B0",
                  "#EF6537",
                  "#C0ADDB",
                ],
                dataLabels: {
                  enabled: true,
                  offsetY: -30,
                  style: {
                    colors: ["#077893"],
                    fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                    fontWeight: 600,
                    cssClass: "apexcharts-yaxis-label",
                  },
                  formatter: function (val) {
                    return val.toLocaleString("en-US");
                  },
                },
                fill: {
                  type: "gradient",
                },
                legend: {
                  show: false,
                },
                tooltip: {
                  theme: "dark",
                  style: {
                    fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                  },
                  x: {
                    show: true,
                  },
                  y: {
                    title: {
                      formatter: function (a, b, c) {
                        return "";
                      },
                    },
                  },
                },
              }),
                (this.chartOptionsEng = {
                  plotOptions: {
                    bar: {
                      distributed: true,
                      columnWidth: "10%",
                      distributed: true,
                      borderRadius: 10,
                      dataLabels: {
                        position: "top",
                        enabled: true,
                      },
                    },
                  },
                  chart: {
                    id: "vuechart-example",
                    toolbar: {
                      show: false,
                    },
                  },
                  xaxis: {
                    categories: this.ymeng,
                    labels: {
                      show: true,
                      style: {
                        fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                        fontWeight: 400,
                        cssClass: "apexcharts-yaxis-label",
                      },
                    },
                  },
                  yaxis: {
                    labels: {
                      show: true,
                      style: {
                        fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                        fontWeight: 400,
                        cssClass: "apexcharts-yaxis-label",
                      },
                      formatter: (val) => {
                        return val.toLocaleString("en-US");
                      },
                    },
                  },
                  colors: [
                    "#3B93A5",
                    "#F7B844",
                    "#ADD8C7",
                    "#EC3C65",
                    "#CDD7B6",
                    "#C1F666",
                    "#D43F97",
                    "#1E5D8C",
                    "#421243",
                    "#7F94B0",
                    "#EF6537",
                    "#C0ADDB",
                  ],
                  dataLabels: {
                    enabled: true,
                    offsetY: -30,
                    style: {
                      colors: ["#077893"],
                      fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                      fontWeight: 600,
                      cssClass: "apexcharts-yaxis-label",
                    },
                    formatter: function (val) {
                      return val.toLocaleString("en-US");
                    },
                  },
                  legend: {
                    show: false,
                  },
                  tooltip: {
                    theme: "dark",
                    style: {
                      fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                    },
                    x: {
                      show: true,
                    },
                    y: {
                      title: {
                        formatter: function (a, b, c) {
                          return "";
                        },
                      },
                    },
                  },
                }),
                (this.series = [
                  {
                    name: "issue",
                    data: this.count,
                  },
                ]);
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            // Toast.fire({
            //   icon: "error",
            //   title:  error.message || error,
            // });
          }
        });
    },
  },
  computed: {
    ...mapGetters(["Profile"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _SelectBusinessId: {
      get() {
        return this.Business.BusinessId || "-";
      },
    },
    _SelectBusinessNameTH: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    // dataToArrayAll() {
    //   return [
    //     this.Status.CountApprove,
    //     this.Status.CountUnApprove,
    //     this.Status.CountWait,
    //     this.Status.CountExpire,
    //   ];
    // },
  },
  mounted() {
    // this.Fn_GetDashboard(); //api consent2
    this.Fn_GetDataDashboard();
  },
  created() {},
  watch: {},
};
</script>

<style>
div#apexchartsvuechart-example {
  display: block;
  margin: auto;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

@media screen and (max-width: 1263px) {
  .flexresponsive {
    display: none !important;
  }
}

h1 {
  color: #077893;
}
</style>
